import dayjs from 'dayjs'
import { ColumnsType } from 'antd/es/table'
import { CARD_EXAMPLE } from './const'

export function isJestTest() {
  return process.env.JEST_WORKER_ID !== undefined
}

export const getServerGoAPI = (path: string) => `${process.env.NEXT_PUBLIC_GO_API_URL}/${path}`
// export const getServerGoAPI = (path: string) => `${API_GO_ROOT_REMOTE}/${path}`

export const isBrowser = () => typeof window !== 'undefined'
export const isServer = () => typeof window === 'undefined'

// historyData 的 updated_at 混用两种格式:Go 记分路径存 unix 秒(整数),Rails 后台改分路径存 ISO 字符串。
// dayjs(number) 默认按毫秒解析 → 秒级时间戳会被显示成 1970 年(如把 5 分钟间隔压成 0.3 秒),
// 让正常比赛看起来像"秒级密集改分"。此处统一归一,避免误判。
export const formatHistoryTime = (t: unknown, fmt = 'YYYY-MM-DD HH:mm:ss'): string => {
  if (t === null || t === undefined || t === '') return '-'
  let d: dayjs.Dayjs
  if (typeof t === 'number' || /^\d+$/.test(String(t))) {
    const n = Number(t)
    d = dayjs(n < 1e12 ? n * 1000 : n) // 10 位=秒→×1000;13 位=毫秒
  } else {
    d = dayjs(t as string) // ISO 字符串
  }
  return d.isValid() ? d.format(fmt) : '-'
}

export enum VIP_LEVEL {
  'NORMAL' = 10,
  'VIP' = 20,
  'SVIP' = 30,
  'SSVIP' = 40,
  'SUPER_ADMIN' = 100,
  'normal' = 10,
  'vip' = 20,
  'svip' = 30,
  'ssvip' = 40,
  'super_admin' = 100,
}

export const teamColumns: ColumnsType = [
  { title: '排名', align: 'center', dataIndex: 'rank', render: (v) => <div className="font-bold">{v}</div> },
  { title: '队名', align: 'center', dataIndex: 'name' },
  { title: '队员1', align: 'center', dataIndex: 'name_user1' },
  { title: '队员2', align: 'center', dataIndex: 'name_user2' },
  { title: '团体', align: 'center', dataIndex: 'guild' },
]

export const spinColumns: ColumnsType = [
  { title: '排名', align: 'center', dataIndex: 'rank', render: (v) => <div className="font-bold">{v}</div> },
  { title: '姓名', align: 'center', dataIndex: 'name' },
]

export const rankToNumber: Record<string, number> = {
  弃权: -10,
  2: 2,
  3: 3,
  4: 4,
  5: 5,
  6: 6,
  7: 7,
  8: 8,
  9: 9,
  10: 10,
  J: 11,
  Q: 12,
  K: 13,
  A: 14,
  'A+': 15,
  'A＋': 15,
  j: 11,
  q: 12,
  k: 13,
  a: 14,
  'a+': 15,
  'a＋': 15,
  '11': 11,
  '12': 12,
  '13': 13,
  '14': 14,
  '15': 15,
  L: 16,
  B: 17,
}

export const excessRankToNumber: Record<string, number> = {
  弃权: -10,
  2: 2,
  3: 3,
  4: 4,
  5: 5,
  6: 6,
  7: 7,
  8: 8,
  9: 9,
  10: 10,
  J: 11,
  Q: 12,
  K: 13,
  A: 14,
  j: 11,
  q: 12,
  k: 13,
  a: 14,
  '2+': 15,
  '3+': 16,
  '4+': 17,
  '5+': 18,
  '6+': 19,
  '7+': 20,
  '8+': 21,
  '9+': 22,
  '10+': 23,
  'J+': 24,
  'Q+': 25,
  'K+': 26,
  'A+': 27,
  'j+': 24,
  'q+': 25,
  'k+': 26,
  'a+': 27,
}

export const numberToRank = {
  '-10': '弃',
  2: 2,
  3: 3,
  4: 4,
  5: 5,
  6: 6,
  7: 7,
  8: 8,
  9: 9,
  10: 10,
  11: 'J',
  12: 'Q',
  13: 'K',
  14: 'A',
  15: 'A+',
}

export const excessNumberToRank = {
  '-10': '弃',
  2: 2,
  3: 3,
  4: 4,
  5: 5,
  6: 6,
  7: 7,
  8: 8,
  9: 9,
  10: 10,
  11: 'J',
  12: 'Q',
  13: 'K',
  14: 'A',
  15: '2+',
  16: '3+',
  17: '4+',
  18: '5+',
  19: '6+',
  20: '7+',
  21: '8+',
  22: '9+',
  23: '10+',
  24: 'J+',
  25: 'Q+',
  26: 'K+',
  27: 'A+',
}

export const roomStatus = {
  10: '空闲',
  20: '等待中',
  30: '比赛中',
  32: '单提交',
  35: '已提交',
  40: '已结束',
  null: '空闲',
}

export enum RoomStatusNum {
  created = 10,
  waiting = 20,
  ongoing = 30,
  halfsubmitted = 32,
  submitted = 35,
  finished = 40,
}

export enum GameStatus {
  stopped = 0,
  started = 1,
  preparing = 2,
}

export enum TradeStatus {
  // 1: 第一局无需供牌，2: 供牌中, 3: 贡牌结束， 4: 抗贡
  noSupply = 1,
  ongoing = 2,
  finished = 3,
  antiSupply = 4,
}

export const roomColor = {
  10: 'text-gray-500',
  20: 'text-green-500',
  30: 'text-blue-500',
  32: 'text-blue-600',
  35: 'text-yellow-500',
  40: 'text-red-500',
  null: 'text-gray-500',
}

export const roomBg = {
  10: 'bg-white',
  20: 'bg-white',
  30: 'bg-white',
  35: 'bg-yellow-100',
  40: 'bg-gray-200',
  null: 'bg-white',
}

export const normalScoresMap = {
  victory_score: '场分',
  score: '级差分',
  victory_count: '胜轮次',
  rank_up_score: '升级数',
  opponent_score: '对手级差分',
  opponent_victory_score: '对手场分',
  max_opponent_victory_score: '最高对手场分',
  score_log: '轮高分',
  guild_victory_score_by_victory: '团体分（依据场分）',
  guild_victory_score_by_score: '团体分（依据级差分）',
}

export const teamGuildSwitzerMatchScoresMap = {
  guild_victory_score_by_victory: '团体分（依据场分）',
  guild_victory_score_by_score: '团体分（依据级差分）',
  victory_score: '场分',
  score: '级差分',
  victory_count: '胜轮次',
  rank_up_score: '升级数',
  opponent_score: '对手级差分',
  opponent_victory_score: '对手场分',
  max_opponent_victory_score: '最高对手场分',
  score_log: '轮高分',
}

export const teamGuildSwitzerGuildScoresMap = {
  guild_victory_score_by_victory: '团体分（依据场分）',
  guild_victory_score_by_score: '团体分（依据级差分）',
  victory_score: '场分',
  score: '级差分',
}

export const teamGuildSwitzerTeamScoresMap = {
  victory_score: '场分',
  score: '级差分',
  victory_count: '胜轮次',
  rank_up_score: '升级数',
  opponent_score: '对手级差分',
  opponent_victory_score: '对手场分',
  max_opponent_victory_score: '最高对手场分',
  score_log: '轮高分',
}

export const duplicatedMatchScoresMap = {
  score: '复式积分',
  score_log: '轮高分',
  opponent_score: '对手分',
}

export const duplicatedTeamMatchScoresMap = {
  victory_score: '复式场分',
  score: '复式积分',
  victory_count: '胜轮次',
  opponent_victory_score: '对手场分',
  opponent_score: '对手积分',
  max_opponent_victory_score: '最高对手场分',
  score_log: '轮高分',
  score_gap: '分差',
}

export const duplicatedSwitzerMatchScoresMap = {
  offset_victory_score: '科学场分',
  offset_score: '科学偏差分',
  offset_median_victory_score: '中位数场分',
  offset_median_victory_score_4_stages: '中位4段场分',
  offset_median_score: '中位数偏差分',
  percent_score: '百分位场分',
  opponent_score: '对手积分',
  opponent_median_victory_score: '对手中位场分',
}

export const duplicatedSpinMatchScoresMap = {
  ranking_victory_score: '排名场分',
  offset_median_victory_score: '中位数场分',
  offset_median_score: '中位数偏差分',
  opponent_ranking_victory_score: '对手场分',
  opponent_offset_median_victory_score: '对手中位场分',
}

export const singlePublicMatchScoresMap = {
  single_public_score: '个人赛积分',
  total_ranking: '名次总计',
  rank_up_score: '升级分',
}

export const pickleballMatchScoresMap = {
  victory_score: '胜场分',
  score: '总得分',
  victory_count: '胜场数',
  opponent_score: '对手总分',
  opponent_victory_score: '对手胜场分',
}

export const spinMatchScoresMap = {
  score: '团团转积分',
  victory_score: '场分',
  victory_count: '胜轮次',
  rank_up_score: '升级数',
  score_log: '轮高分',
  opponent_score: '对手分',
  max_opponent_victory_score: '最高对手场分',
}

export const threePlayersMatchScoresMap = {
  victory_score: '场分',
  score: '小分',
}

export const specialScoresMap = {
  victory_score: '积分',
  score: '级差分',
  victory_count: '胜轮次',
  rank_up_score: '升级数',
  opponent_score: '对手级差分',
  opponent_victory_score: '对手分',
  max_opponent_victory_score: '最高对手分',
  score_log: '轮高分',
}

export const fourPlayersTeamMatchScoresMap = {
  victory_score: '场分',
  turn_score: '局分',
  score: '级差分',
  mp_scpre: 'mp分',
  imp_scpre: 'imp分',
}

export const bridgeMatchScoresMap = {
  victory_score: '场分',
  score: '积分',
}

export const groupRoundRobinScoresMap = {
  victory_count: '胜场数',
  score: '总积分',
  victory_score: '胜场分',
  opponent_score: '对手总分',
}

export const getScoresMap = (match_type) => {
  let map: Record<string, string> = normalScoresMap
  if (match_type === 'group_round_robin') {
    return groupRoundRobinScoresMap
  }
  if (match_type === 'team_guild_switzer') {
    map = teamGuildSwitzerMatchScoresMap
  } else if (match_type === 'duplicated_switzer') {
    map = duplicatedSwitzerMatchScoresMap
  } else if (match_type === 'duplicated_team') {
    map = duplicatedTeamMatchScoresMap
  } else if (match_type === 'duplicated_spin') {
    map = duplicatedSpinMatchScoresMap
  } else if (match_type.includes('duplicated')) {
    map = duplicatedMatchScoresMap
  } else if (match_type === 'single_public') {
    map = singlePublicMatchScoresMap
  } else if (match_type === 'spin') {
    map = spinMatchScoresMap
  } else if (match_type === 'three_players') {
    map = threePlayersMatchScoresMap
  } else if (match_type === 'four_players_team') {
    map = fourPlayersTeamMatchScoresMap
  } else if (match_type === 'bridge') {
    map = bridgeMatchScoresMap
  } else if (['pickleball', 'pickleball_single', 'pickleball_round_robin', 'pickleball_elimination', 'pickleball_group_elimination'].includes(match_type)) {
    map = pickleballMatchScoresMap
  }
  return map
}

export const scoreToColumn = (i, match_type = '') => {
  const map = getScoresMap(match_type)

  return {
    title: map[i] || '积分',
    data: i,
  }
}

export const isSinglePlayerMatch = (match_type) => {
  return ['single', 'spin', 'single_public', 'duplicated_single', 'duplicated_spin', 'three_players', 'pickleball_single'].includes(match_type)
}

export const isPickleballMatch = (match_type) => {
  return ['pickleball', 'pickleball_single', 'pickleball_round_robin', 'pickleball_elimination', 'pickleball_group_elimination'].includes(match_type)
}

export const isPickleballGroupElimination = (match_type) => {
  return match_type === 'pickleball_group_elimination'
}

// Translate legacy "X号桌" room names to "X号场地" for pickleball display.
// Backend now generates "号场地" directly for new pickleball rooms; this only affects existing rows.
export const displayRoomName = (name: string | undefined, match_type: string | undefined): string => {
  if (!name) return ''
  if (isPickleballMatch(match_type)) return name.replace(/号桌/g, '号场地')
  return name
}

export const isTeamMatchType = (match_type) => {
  return ['team', 'double_loss', 'team_guild_switzer'].includes(match_type)
}

export const allowOnlineGameMatch = (match_type) => {
  // TODO: 暂时下架duplicated_switzer
  return ['spin', 'team', 'duplicated_spin'].includes(match_type)
  // return ['spin', 'team', 'duplicated_spin', 'duplicated_switzer'].includes(match_type)
}

// Get the default link for a match based on its type
export const getMatchLink = (match_id: string, match_type: string) => {
  if (match_type === 'banquet') {
    return `/match/${match_id}/banquet/settings`
  }
  if (isSinglePlayerMatch(match_type)) {
    return `/match/${match_id}/players_score`
  }
  return `/match/${match_id}/teams_score`
}

export const normalMatchType = {
  team: '双人赛（组队赛）',
  banquet: '活动抽奖',
}

export const svipMatchMap = {
  single: '单人赛',
  circle: '循环赛',
  group_round_robin: '团队分组循环赛',
  double_loss: '双败制',
  spin: '团团转',
}

export const ssvipMatchMap = {
  single_public: '单人赛(全国个人公开赛)',
  excess: '超分赛(过A继续打)',
  duplicated: '米切尔复式赛',
  duplicated_single: '单人复式循环赛',
  duplicated_team: '四人队式开闭室复式赛',
  duplicated_switzer: '瑞士偏差分复式赛',
  duplicated_spin: '偏差分团团转复式赛',
  three_players: '三人赛（内测）',
  four_players_team: '四人手抓牌升级赛',
  shuang_sheng: '双升',
  league: '联赛',
  bridge: '桥牌',
  zhong_hua_qiao_pai: '中华侨牌(6人)',
  team_guild_switzer: '团队瑞士移位赛',
}

export const pickleballMatchMap = {
  pickleball: '球拍类双打赛',
  pickleball_single: '球拍类单打赛',
  pickleball_round_robin: '球拍类循环赛',
  pickleball_elimination: '球拍类淘汰赛',
  pickleball_group_elimination: '球拍类小组淘汰赛',
}

export const matchTypeIntro = {
  pickleball: '匹克球/网球/羽毛球/乒乓球等 2v2 双打，瑞士制轮次编排，按胜场/总分排名（计分规则可配置）',
  pickleball_single: '匹克球/网球/羽毛球等 1v1 单打，按胜场/总分排名（计分规则可配置）',
  pickleball_round_robin: '球拍类项目循环赛，所有队伍两两对阵一次，适合小规模锦标赛',
  pickleball_elimination: '球拍类单败淘汰，每轮负方退出，直至产生冠军',
  pickleball_group_elimination: '球拍类小组循环 + 单败淘汰：蛇形分组循环，每组取前 N 名进入淘汰赛。适用于匹克球/网球/羽毛球/乒乓球等 8-32 人锦标赛',
  team: '最基本的双人组队比赛,支持瑞士轮',
  double_loss: '双人组队赛变体：上一轮胜方坐东西、负方坐南北，胜方对负方；平局按东西方胜、南北方负计。',
  team_guild_switzer: '以团体为单位进行瑞士移位编排，团体先对阵，再由同名次队伍逐桌交锋，并记录团体大分(胜2/平1/负0)',
  single: '最基本的单人比赛,每轮均换搭档',
  circle: '双人单循环赛,每队均对抗一次',
  group_round_robin: 'X 队分 Y 组、每组 N 队组内循环（种子尽量分到不同组）；裁判长手动登整数比分，自动出小组内+全场总积分榜',
  spin: '也称为转蛋,按个人记分,每打一副都换搭档',
  single_public: '为特定用户专门定制开发的比赛',
  excess: '过A之后可以继续升级',
  duplicated: '米切尔复式赛,双冠军制',
  duplicated_single: '为特定用户专门定制开发的比赛',
  duplicated_team: '每队4名选手,分为开闭室的复式赛',
  duplicated_switzer: '每队两名选手,不分开闭室,计算偏差分',
  duplicated_spin: '每队一名选手,基于团团转形式的复式赛',
  three_players: '三人一桌，个人独立记场分和小分，裁判手动结算',
  league: '为特定用户专门定制开发的比赛',
  four_players_team: '四人一队手抓牌升级赛，按队计分',
  shuang_sheng: '双升（八十分），两副牌四人对家制，升级打法',
  bridge: '标准桥牌，叫牌 + 打牌，按定约成败计分',
  zhong_hua_qiao_pai: '中华侨牌，6 人一桌的桥牌变体',
  online_spin: '团团转线上版',
  online_duplicated_spin: '复式团团转线上版',
  banquet: '活动抽奖系统,支持多种抽奖形式(纪念奖、三等奖、二等奖、一等奖、特等奖),微信扫码签到,实时投屏展示',
}

export const matchTypeMap = {
  ...normalMatchType,
  ...svipMatchMap,
  ...ssvipMatchMap,
  ...pickleballMatchMap,
}

// 创建弹窗里赛制下拉的展示顺序 = 生产库近半年实际创建量降序（2026-09-21 统计）。
// 目的是让 95% 的用户在前三项就找到自己要的（双人赛 3272 场 / 单人赛 185 / 团团转 158）。
// 想调顺序请先重新跑一次统计，别按印象排：
//   select match_type, count(*) from matches where deleted_at is null
//     and created_at > now() - interval '180 days' group by 1 order by 2 desc;
export const cardMatchTypeOrder = [
  'team',
  'single',
  'spin',
  'duplicated_team',
  'duplicated_switzer',
  'circle',
  'group_round_robin',
  'three_players',
  'duplicated',
  'team_guild_switzer',
  'single_public',
  'excess',
  'double_loss',
  'league',
  'four_players_team',
  'banquet',
  'shuang_sheng',
  'duplicated_single',
  'zhong_hua_qiao_pai',
  'duplicated_spin',
  'bridge',
  'online_spin',
  'online_duplicated_spin',
]

export const otherMatchTypeOrder = [
  'pickleball_group_elimination',
  'pickleball',
  'pickleball_round_robin',
  'pickleball_single',
  'pickleball_elimination',
]

export const onlineMatchTypeMap = {
  online_spin: '线上-团团转',
  online_duplicated_spin: '线上-偏差分团团转复式赛',
}

export const VipLevelMap = {
  10: 'NORMAL',
  20: 'VIP',
  30: 'SVIP',
  40: 'SSVIP',
}

// 面向用户展示的会员称号(普通/VIP/专业VIP/旗舰VIP),用于头像菜单、个人中心等。
export const vipTierName = (level?: number): string => {
  if (!level || level <= 10) return '普通用户'
  if (level >= 100) return '管理员'
  if (level >= 40) return '旗舰VIP用户'
  if (level >= 30) return '专业VIP用户'
  if (level >= 20) return 'VIP用户'
  return '普通用户'
}

export const formatOneIntegerCard = (cardNumber) => {
  const formated = CARD_EXAMPLE[cardNumber]
  if (!formated) {
    return {}
  }
  return { suit: formated.slice(-1), point: formated.slice(0, -1), pointNumber: rankToNumber[formated.slice(0, -1)], num: cardNumber }
}

export const formatIntegerCards = (cards: number[]) => (cards ?? []).map((c) => formatOneIntegerCard(c))

const direction = ['东', '南', '西', '北']

export const formatCards = (cards) => {
  const res = { 东: [], 南: [], 西: [], 北: [] }
  for (let i = 0; i < cards.length; i += 1) {
    if (cards[i].length > 0) {
      res[direction[3 - i]] = cards[i]
    }
  }
  return res
}

export const statsKeyMap = {
  team1_rank12: '东西方一二游',
  team1_rank13: '东西方一三游',
  team1_rank14: '东西方一四游',
  team2_rank12: '南北方一二游',
  team2_rank13: '南北方一三游',
  team2_rank14: '南北方一四游',
}

export const clubMap = {
  tianhehui: '天和汇',
  yong: '雍冠',
  laoyangfang: '老洋房',
  wzw: '王中王',
}

export const dealMode = {
  suited: '同花色',
  bomb: '天王炸',
  random: '随机',
  bridge: '桥牌',
  bridge_balanced: '桥牌均衡',
  fun: '不洗牌',
  fair: '均衡',
  fair_v2: '均衡',
  diy: '自选牌',
  doudizhu: '斗地主随机',
  doudizhu_balanced: '斗地主均衡',
  doudizhu_suited: '斗地主同花',
  many_bombs: '指定炸',
}

export const numberToRankFunc = (rank, is_excess_match = false, match_type = '', direct_count_score = false) => {
  if (rank === undefined || rank === null) {
    return null
  }
  if (parseInt(rank, 10) === -10) {
    return '弃'
  }

  if (direct_count_score) {
    return rank
  }
  if (match_type.startsWith('spin')) {
    return rank
  }
  if (match_type.startsWith('duplicated')) {
    return rank
  }
  if (match_type === 'four_players_team') {
    return rank
  }
  if (match_type === 'bridge') {
    return <div className="h-full text-xl">{rank}</div>
  }
  if (parseInt(rank, 10) === 10) {
    return (
      <span>
        <span>1</span>
        <span className="ml-[-0.1125em]">0</span>
      </span>
    )
  }
  if (parseInt(rank, 10) < 15) {
    return <span>{numberToRank[rank]}</span>
  }
  if (is_excess_match) {
    return (
      <span className="text-yellow-600">
        {numberToRank[parseInt(rank, 10) - 13]}
        <span className="absolute -mt-1 ml-[-0.25em] text-lg font-black">+</span>
      </span>
    )
  }
  if (parseInt(rank, 10) > 15) {
    return <span>err</span>
  }
  return (
    <span className="text-yellow-600">
      A<span className="absolute -mt-1 ml-[-0.25em] text-lg font-black">+</span>
    </span>
  )
}

export const turnOptions = (turn) => {
  return [...Array(turn ?? 3)].map((_, num) => ({ value: num + 1, label: `${num + 1}` }))
}
